import formatClasses from '@/utils/classes/formatClasses'
import { Bar } from '@/components'
import Text from '@/components/Text'
import twMerge from '@/utils/classes/twMerge'
import { match } from 'ts-pattern'

type ProgressBarFunction = (step: number, numberOfSteps: number) => string

type ProgressBarTextType =
  | 'numbers'
  | 'percent'
  | 'hidden'
  | ProgressBarFunction

type ProgressBarProps = {
  step: number
  numberOfSteps: number
  textType?: ProgressBarTextType
  className?: string
  layoutId?: string
}
export function ProgressBar(props: ProgressBarProps) {
  const classes = {
    progressBar: formatClasses(['progress-bar']),
    progress: formatClasses(['progress']),
  }
  return (
    <div
      className={twMerge('flex flex-row gap-6 items-center', props.className)}
    >
      <Text
        style={{
          fontVariantNumeric: 'tabular-nums',
        }}
        className={'min-w-fit text-themed-blue-500'}
      >
        {match(props.textType)
          .when(
            (type): type is ProgressBarFunction => typeof type === 'function',
            (func) => func(props.step, props.numberOfSteps),
          )
          .when(
            (type) => type === 'percent',
            () =>
              `${Math.floor(
                (props.step / props.numberOfSteps) * 100,
              )}% Complete`,
          )
          .when(
            (type) => type === 'hidden',
            () => '',
          )
          .otherwise(() => `${props.step} of ${props.numberOfSteps} complete`)}
      </Text>
      <Bar className={classes.progressBar}>
        <Bar
          className={classes.progress}
          layoutId={props.layoutId ?? 'pageLevelProgressBar'}
          style={{
            background: 'var(--color-blue-500)',
          }}
          initial={{
            width: `clamp(2%, calc(100% * ${props.step} / ${props.numberOfSteps}), 100%)`,
          }}
          animate={{
            width: `clamp(2%, calc(100% * ${props.step} / ${props.numberOfSteps}), 100%)`,
          }}
          transition={{
            type: 'spring',
            stiffness: 120,
            damping: 20,
          }}
        />
      </Bar>
    </div>
  )
}
